import { postRequest, ApiResponse } from "@/data/apiClient";
import { UserDetails } from "@/data/repos/commonModels";

export interface userUpdateResponse {
  id: number;
}

export async function userUpdate(
  user: UserDetails
): Promise<ApiResponse<userUpdateResponse>> {
  return postRequest("user/update", user);
}

export async function setUserProfiles(
  userId: number,
  userProfileIds: number[]
): Promise<ApiResponse<userUpdateResponse>> {
  return postRequest("user/setUserProfiles", { userId, userProfileIds });
}
